<template>
  <div
    class="CommunityInformation mt-3 pb-3 border-inverted border-bottom border-thick"
  >
    <h2 class="mb-2 ml-2 font-weight-bold font-smaller">Communities</h2>
    <div class="pl-2 font-smaller">
      <nuxt-link v-if="isCOE" :to="communityUrl">{{ communityName }}</nuxt-link>
      <a v-else :href="communityUrl">{{ communityName }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommunityInformation",
  props: {
    article: { type: Object, required: true },
  },

  computed: {
    isCOE() {
      return this.$config.partner.toLowerCase() === "coe";
    },
    communityName() {
      return this.article.community.name;
    },
    communityUrl() {
      return `/engage/coe/community-details/${this.article.communityId}?show=overview`;
    },
  },
};
</script>
